import { render } from "./PoliticaIA.vue?vue&type=template&id=4f0fed32"
import script from "./PoliticaIA.vue?vue&type=script&lang=js"
export * from "./PoliticaIA.vue?vue&type=script&lang=js"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__